import { useMutation, gql } from "@apollo/client"
import { GROUP_FIELDS } from "./useQueryGroups"

const CREATE_GROUP_MUTATION = gql`
  mutation CreateGroup($name: String!, $description: String, $locations: [ID!]) {
    createGroup(name: $name, description: $description, locations: $locations) {
      ${GROUP_FIELDS}
    } 
  }
`

const useMutationCreateGroup = () => useMutation(CREATE_GROUP_MUTATION)

export { useMutationCreateGroup }
